import { useMemo, useState } from 'react'

import Button from '../app/design/Button'
import Label from '../app/design/Label'
import Modal from '../app/design/Modal'
import { TextField } from '../common/fields/TextField'

export enum ReportNameModalType {
    SaveAs,
    Rename,
}

type ReportNameModalProps = {
    type: ReportNameModalType
    initialName: string | undefined
    onDone: (name: string) => void
    onClose: () => void
}

export const ReportNameModal = ({ type, initialName, onDone, onClose }: ReportNameModalProps) => {
    const title = useMemo(() => {
        switch (type) {
            case ReportNameModalType.SaveAs:
                return 'Save as new report'
            case ReportNameModalType.Rename:
                return 'Rename report'
            default:
                return ''
        }
    }, [type])

    const header = useMemo(() => {
        switch (type) {
            case ReportNameModalType.SaveAs:
            case ReportNameModalType.Rename:
                return 'Report name'
            default:
                return ''
        }
    }, [type])

    const placeholder = useMemo(() => {
        switch (type) {
            case ReportNameModalType.SaveAs:
            case ReportNameModalType.Rename:
                return 'Enter report name'
            default:
                return ''
        }
    }, [type])

    const [name, setName] = useState<string>(initialName ?? '')

    return (
        <Modal
            isOpen
            title={title}
            onClose={onClose}
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    <Button intent="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button intent="primary" onClick={() => onDone(name)} disabled={!name}>
                        Done
                    </Button>
                </div>
            }
            children={
                <div className="flex flex-col gap-3">
                    <Label className="text-gray-700">{header}</Label>
                    <TextField
                        size="medium"
                        placeholder={placeholder}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
            }
        />
    )
}
